import { Id } from '@nextforce/api'

const keys = {
  all: ['tools'],
  list: (storeId: Id) => [...keys.all, storeId],
}

export default keys
